import { FlashManagerReportRequestModel } from '../api/models/FlashManagerReportRequestModel';
import { FlashManagerReportFormModel } from '../models';

export const dataFormToRequest = (
  data: FlashManagerReportFormModel
): FlashManagerReportRequestModel => ({
  date: data.date,
  show_net: data.show_net,
  file_type: data?.file_type,
});
